<div class="stock-hold-timeout-page p-6 flex-table-page" data-testid="stock-hold-timeout-page">
  <div class="mb-4 flex-table-header">
    <h2 class="text-2xl font-semibold text-gray-800">
      {{ 'stock_hold_timeout.title' | translate }}
    </h2>
    <p class="text-sm text-gray-500 mt-1">
      {{ 'stock_hold_timeout.subtitle' | translate }}
    </p>
  </div>

  <div class="mb-4">
    <app-search-form
      [searchFormat]="searchFormConfig()"
      (formSearch)="onSearch($event)"
      (formReset)="onReset()"
    >
      <div slot="actions" class="flex gap-2">
        <app-button
          type="success"
          [outlined]="true"
          icon="view_column"
          (emitOnClick)="onColumnConfigClick($event)"
        />
        @if (canCreate()) {
          <app-button
            [label]="'common.actions.new' | translate"
            type="info"
            [disabled]="!canAddNew()"
            (emitOnClick)="onAdd()"
          />
        }
      </div>
    </app-search-form>
  </div>

  <div class="flex-table-section">
    <advanced-data-table
      #advancedTable
      [dataSource]="configs()"
      [defaultColumns]="defaultColumns()"
      [flexibleColumns]="flexibleColumns()"
      [loading]="loading()"
      [hasCheckColumn]="false"
      [showInternalColumnConfigButton]="false"
      [first]="page() * rows"
      [rows]="rows"
      [totalRecords]="totalRecords()"
      [rowsPerPageOptions]="[20, 50, 100]"
      scrollHeight="flex"
      (pageChange)="onPageChange($event)"
      class="w-full"
    >
    <ng-template #customTemplate let-value let-column="column" let-rowData="rowData">
      @if (column?.template === 'categoryTemplate') {
        <span class="text-xs text-gray-700">{{ getCategoryLabel(rowData.holdCategory) }}</span>
      }
    </ng-template>

    <ng-template #statusTemplate let-status>
      <div class="flex items-center justify-center gap-1">
        <p-tag
          [value]="getStatusDisplayText(status)"
          [severity]="getStatusSeverity(status)"
          styleClass="status-tag"
          [ngStyle]="getStatusStyle(status)"
          [pTooltip]="getStatusDisplayText(status)"
          tooltipPosition="top"
          tooltipStyleClass="custom-tooltip"
          [showDelay]="300"
          [hideDelay]="0"
        />
      </div>
    </ng-template>

    <ng-template #actionsTemplate let-rowData>
      <div class="flex gap-2 justify-center flex-wrap">
        @if (canUpdate()) {
          <app-button
            class="action-edit"
            [label]="'common.actions.edit' | translate"
            type="action"
            (emitOnClick)="onEdit(rowData)"
          />
          <app-button
            [class]="rowData.enabled ? 'action-disable' : 'action-enable'"
            [label]="
              rowData.enabled
                ? 'stock_hold_timeout.actions.deactivate'
                : 'stock_hold_timeout.actions.activate'
            "
            type="action"
            (emitOnClick)="onToggleStatus(rowData, !rowData.enabled)"
          />
        }
        @if (canDelete() && !rowData.enabled) {
          <app-button
            class="action-delete"
            [label]="'common.actions.delete' | translate"
            type="action"
            (emitOnClick)="onDelete(rowData)"
          />
        }
      </div>
    </ng-template>
    </advanced-data-table>
  </div>
</div>

<p-toast />

<app-confirmation-dialog
  [visible]="showConfirmationDialog()"
  (visibleChange)="showConfirmationDialog.set($event)"
  [title]="confirmationTitle()"
  [message]="confirmationMessage()"
  [buttons]="confirmationButtons()"
  (emitOnClick)="onConfirmationDialogAction($event)"
/>
